import React from 'react';
import PropTypes from 'prop-types';
import { withFormik, Field, FieldArray } from 'formik';
import Yup from 'yup';
import { map, uniqueId } from 'lodash';
import { getFormValue } from '../../../util/helpers';
import {
  AddButton,
  AddressForm,
  ContactInfoForm,
  FaxField,
  FormLayout,
  FormSectionHeader,
  getAddressValidation,
  getContactInfoValidation,
  getFaxValidation,
  getNameValidation,
  getPracticeNameValidation,
  getUrlValidation,
  GridContainer,
  GridItem,
  NameForm,
  PracticeNameField,
  TextFieldWrapper,
  UrlField,
} from '../../common';

import ContactForm from './ContactForm';

const NOTES = 'notes';
const OTHER_CONTACTS = 'otherContacts';

const getNewContact = () => ({
  contactRole: '',
  email: '',
  firstName: '',
  id: undefined,
  lastName: '',
  primaryPhoneNumber: '',
  otherContacts: '',
  tempId: uniqueId('temp-'),
});

const renderOtherContacts = ({ fieldArray, props }) => {
  const { setFieldValue, values } = props;
  return (
    <React.Fragment>
      {map(values[OTHER_CONTACTS], (contact, index) => (
        <div key={contact.id || contact.tempId}>
          <FormSectionHeader
            onRemove={() => fieldArray.remove(index)}
            title={`Other Contact ${index + 1}`}
          />
          <ContactForm
            paths={[fieldArray.name, index]}
            setFieldValue={setFieldValue}
            values={values}
          />
        </div>
      ))}
      <AddButton onClick={() => fieldArray.push(getNewContact())}>
        Add Other Contact
      </AddButton>
    </React.Fragment>
  );
};

renderOtherContacts.propTypes = {
  fieldArray: PropTypes.array.isRequired,
  props: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

function PrimaryDoctorForm(props) {
  const { setFieldValue, values } = props;
  return (
    <FormLayout {...props}>
      <GridContainer>
        <NameForm lastNameRequired />
        <PracticeNameField />
        <AddressForm required={false} />
        <ContactInfoForm
          hasExtension
          setFieldValue={setFieldValue}
          values={values}
        />
        <FaxField setFieldValue={setFieldValue} values={values} />
        <UrlField />
        <GridItem lg={12} xs={12}>
          <Field
            component={TextFieldWrapper}
            id={NOTES}
            label="Notes"
            multiline
            name={NOTES}
          />
        </GridItem>
        <FieldArray
          name={OTHER_CONTACTS}
          render={fieldArray => renderOtherContacts({ fieldArray, props })}
        />
      </GridContainer>
    </FormLayout>
  );
}

PrimaryDoctorForm.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  data: PropTypes.object,
};

PrimaryDoctorForm.defaultProps = {
  data: {},
};

const getContactValues = props => ({
  id: props.id,
  email: getFormValue(props, 'email', ''),
  firstName: getFormValue(props, 'firstName', ''),
  lastName: getFormValue(props, 'lastName', ''),
  phoneExtension: getFormValue(props, 'phoneExtension', ''),
  primaryPhoneNumber: getFormValue(props, 'primaryPhoneNumber', ''),
  contactRole: getFormValue(props, 'contactRole', ''),
});

export default withFormik({
  displayName: 'Primary Doctor',
  handleSubmit: (values, { props, setStatus }) =>
    props
      .onSave(values)
      .then(() => (props.isEditing ? props.onCancel() : props.onContinue()))
      .catch(error => setStatus({ saveError: error })),
  mapPropsToValues: ({ data, data: { otherContacts } }) => {
    return {
      id: data.id,
      addressId: data.addressId,
      addressState: getFormValue(data, 'addressState', ''),
      city: getFormValue(data, 'city', ''),
      email: getFormValue(data, 'email', ''),
      fax: getFormValue(data, 'fax', ''),
      firstName: getFormValue(data, 'firstName', ''),
      lastName: getFormValue(data, 'lastName', ''),
      phoneExtension: getFormValue(data, 'phoneExtension', ''),
      practiceName: getFormValue(data, 'practiceName', ''),
      primaryPhoneNumber: getFormValue(data, 'primaryPhoneNumber', ''),
      secondaryStreetAddress: getFormValue(data, 'secondaryStreetAddress', ''),
      streetAddress: getFormValue(data, 'streetAddress', ''),
      url: getFormValue(data, 'url', ''),
      zipCode: getFormValue(data, 'zipCode', ''),
      notes: getFormValue(data, NOTES, ''),
      otherContacts: map(otherContacts, getContactValues),
    };
  },
  validationSchema: Yup.object().shape({
    ...getAddressValidation({ required: false }),
    ...getContactInfoValidation(),
    ...getFaxValidation(),
    ...getNameValidation({ lastNameRequired: true }),
    ...getPracticeNameValidation(),
    ...getUrlValidation(),
  }),
})(PrimaryDoctorForm);



// WEBPACK FOOTER //
// ./src/modules/PrimaryDoctorPage/components/PrimaryDoctorForm.js